export const Data = [
  { id: "id_1213", amount: "$100", status: "Pending" },
  { id: "id_3441", amount: "$400", status: "Paid" },
  { id: "id_6642", amount: "$1100", status: "Pending" },
  { id: "id_3321", amount: "$220", status: "Paid" },
  { id: "id_7753", amount: "$600", status: "Pending" },
];
